// @flow

import clsx from 'clsx';
import React, { PureComponent } from 'react';

declare var interfaceConfig: Object;

/**
 * The type of the React {@code Component} props of {@link PopupOverlay}.
 */
type Props = {

    /**
     * The children components to be displayed into the overlay frame.
     */
    children: React$Node,

    className: String,

    /**
     * Indicates the css style of the overlay. If true, then lighter; darker,
     * otherwise.
     */
    isLightOverlay?: boolean
};

/**
 * The type of the React {@code Component} state of {@link PopupOverlay}.
 */
type State = {

    /**
     * Whether or not the application is currently displaying in filmstrip only
     * mode.
     */
    filmstripOnly: boolean
};

/**
 * Implements a React {@link Component} for the frame of the overlays.
 */
export default class PopupOverlay extends PureComponent<Props, State> {
    /**
     * Initializes a new AbstractOverlay instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     * @public
     */
    constructor(props: Props) {
        super(props);

        this.state = {
            /**
             * Indicates whether the filmstrip only mode is enabled or not.
             *
             * @type {boolean}
             */
            filmstripOnly:
            typeof interfaceConfig !== 'undefined'
            && interfaceConfig.filmStripOnly
        };
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        const { className, children } = this.props;
        const { filmstripOnly } = this.state;

        return (
            <div
                className={clsx('popup__container', { 'filmstrip-only': filmstripOnly }, className)}>
                <div id='popup-overlay'/>
                <div className="popup__content__wrapper">
                    <div className={clsx('popup__content', { 'filmstrip-only': filmstripOnly })}>
                        {React.Children.map(children, child => child)}
                    </div>
                </div>
            </div>
        );
    }
}
